// 简单的版本检测工具，Vue3项目可直接调用
export async function checkVersion(currentVersion, onUpdate) {
  try {
    const res = await fetch('/version.json?_t=' + Date.now());
    const data = await res.json();
    console.log(`当前版本--${currentVersion, data.version}`,`线上版本--${data.version}` )
    if (data.version !== currentVersion && onUpdate) {
      console.log('旧版本需要更新')
      onUpdate(data.version);
    }
  } catch (e) {
    // 可根据需求添加上报
    // console.warn('版本检测失败', e)
  }
}
